<template>
  <div class="child-modal">
    <div class="content-box" ref="content" v-if="chartData">
      <div class="title">
        <ul class="tab">
          <li>
            <div @click="scenicListShow = !scenicListShow" class="expand">
              <div class="icon">
                <img src="../../assets/header_menu/spot.png" />
              </div>
              <div class="drop-name">{{scenicSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="scenicListShow">
                <li :key="index"
                    @click="scenicSelected = item"
                    v-for="(item, index) in scenicList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="dateListShow = !dateListShow" class="expand">
              <div class="icon">
                <img src="../../assets/header_menu/time.png" />
              </div>
              <div class="drop-name">{{dateSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="dateListShow">
                <li :key="index"
                    @click="dateSelected = item"
                    v-for="(item, index) in dateList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="sortListShow = !sortListShow" class="expand">
              <div class="icon">
                <img src="../../assets/sort.png" />
              </div>
              <div class="drop-name">{{sortSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="sortListShow">
                <li :key="index"
                    @click="sortSelected = item"
                    v-for="(item, index) in sortList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div @click="typeListShow = !typeListShow" class="expand">
              <div class="icon">
                <img src="../../assets/index/content.png" />
              </div>
              <div class="drop-name">{{typeSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="typeListShow">
                <li :key="index"
                    @click="typeSelected = item"
                    v-for="(item, index) in typeList">
                  {{ item }}
                </li>
              </ul>
            </div>
          </li>
        </ul>
<div class="search">
        <input type="text" placeholder="输入关键词搜索" />
        <div class="search-btn"></div>
      </div>
      </div>


      

      <div class="content">
          <div style="float:left;">实时预警舆情</div>
          <div class="topbar">
            <div>摘要</div>
            <div>发布时间</div>
            <div>数据来源</div>
            <div>景区</div>
          </div>
          <div class="wrapper">
              <ul class="table">
                <li :key="index"
                    v-for="(item, index) in chartData.earlyWarning"
                    @click="goSpotRealtime">
                  <div>{{ item.sortContent }}</div>
                  <div>{{ item.publishDate }}</div>
                  <div>{{ item.source }}</div>
                  <div>{{ item.scenic }}</div>
                </li>
              </ul>
          </div>

          <div class="page">
            <PageHelper
              @jumpPage="jumpPage"
              :page-number="pageNumber"
            ></PageHelper>
          </div>

          <div style="height: 50px"></div>

          <div style="float:left;">实时负面评价</div>
          <div class="topbar">
            <div>摘要</div>
            <div>发布时间</div>
            <div>数据来源</div>
            <div>景区</div>
          </div>
          <div class="wrapper">
              <ul class="table">
                <li :key="index"
                    v-for="(item, index) in chartData.earlyNegative"
                    @click="goSpotRealtime"  code="605">
                  <div>{{ item.sortContent }}</div>
                  <div>{{ item.publishDate }}</div>
                  <div>{{ item.source }}</div>
                  <div>{{ item.scenic }}</div>
                </li>
              </ul>
          </div>

          <div class="page">
            <PageHelper
                    @jumpPage="jumpPage"
                    :page-number="pageNumber"
            ></PageHelper>
          </div>

      </div>
      
    </div>
  </div>
</template>

<script>
import PageHelper from "@/components/Common/PageHelper.vue";
import BScroll from "@/components/Common/BScroll.vue";

export default {
  name: "Table",
  components: {
    PageHelper,
    BScroll
  },
  props: {
    chartData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      pageNumber: 1,
      tableData: [],

      scenicSelected: "黄山",
      scenicListShow: false,
      scenicList: ["黄山","泰山","衡山"],

      dateSelected: "一周内",
      dateListShow: false,
      dateList: ["一周内","一月内","三月内","一年内"],

      sortSelected: "时间",
      sortListShow: false,
      sortList: ["时间","热度"],

      typeSelected: "综合",
      typeListShow: false,
      typeList: ["综合","新闻资讯","论坛","贴吧","博客","微博","微信","OTA","视频","问答"],

    };
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.$refs.content.style.transform = 'translate(-50%, -50%) scale(0.1)'
      setTimeout(() => {
        this.$store.commit('setLvyouyuqingxiangqingShow')
      }, 300)
    },
    jumpPage(pageinfo) {
      console.log(pageinfo);
    },
    goSpotRealtime() {
      this.$store.commit('setLvyouyuqingxiangqingShow')
    }
  }
};
</script>

<style scoped lang="less">
h2 {
  font-size: 10rem;
  color: #fff;
}
.close {
    width: 0.22rem;
    height: 0.23rem;
    background: url(../../assets/close.png);
    background-size: 100% 100%;
    position: absolute;
    top: 0.14rem;
    right: 0.14rem;
    z-index: 99;
    cursor: pointer;
}
.child-modal {
  width: 100%;
  height: 100%;
  /*background: rgba(0, 0, 0, 0.2);*/
  position: absolute;
  left: -70%;
  top: 300%;
  .content-box {
    padding: 0.3rem;
    box-sizing: border-box;
    /*width: 12rem;*/
    /*height: 10rem;*/
    position: absolute;
    /*left: 50%;*/
    /*top: 50%;*/
    /*transform: translate(-50%, -50%) scale(0.5);*/
    /*transition: all 0.3s;*/
    /*background: rgba(0, 0, 0, 0.5) url(../../assets/spot_bg.jpg);*/
    background-size: 100% 100%;
    box-shadow: 0 0 1.2rem rgba(0, 0, 0, 0.8);
    .title {
      height: 0.5rem;
      font-size: 0.18rem;
      color: #00cdf9;
      font-weight: bold;
      float: left;
        width: 100%;
        position: relative;
      .tab {
        /*width: 3.5rem;*/
        /*height: 0.3rem;*/
        /*margin: 0 auto 0.16rem;*/

        > li {
          width: 1.5rem;
          height: 0.34rem;
          line-height: 0.3rem;
          float: left;
          color: @base-text-color;
          margin-right: 0.1rem;
          cursor: pointer;
          > div {
            float: left;
          }
          .expand {
            /*width: 1.5rem;*/
            height: 0.3rem;
            position: absolute;
            cursor: pointer;
            > div {
              float: left;
              /*width: 0.3rem;*/
              height: 0.3rem;
              line-height: 0.3rem;
                margin-left: 0.1rem;
            }
            .local {
              width: 0.3rem;
              background: url(../../assets/youkexianxiaxingweifenxi/local.png);
              background-size: 100% 100%;
            }
            .arrow {
              width: 30px;
              height: 0.3rem;
              background: url(../../assets/header_menu/arrow.png);
              background-size: 100% 100%;
                margin: 0;
            }
            .icon {
              width: 20px;
              height: 20px;
              margin-top : -3px;
            }
            .drop-list {
              z-index: 9999;
              position: absolute;
              left: 0;
              top: 0.3rem;
              width: 100%;
              background: #052148;
              border: 1px solid #00cdff;
              padding: 0.05rem 0;
              box-sizing: border-box;
              li:hover {
                background: #0c3964;
              }
            }
          }
        }
      }


    }
    .search {
      width: 2.3rem;
      height: 0.26rem;
      position: absolute;
      top: 0;
      right: 0.3rem;
      input {
        width: 2.02rem;
        height: 0.3rem;
        background: #0e264b;
        border: 0.02rem solid #07779e;
        outline: none;
        float: left;
        padding-left: 0.1rem;
        color: #fff;
          font-size: 0.16rem;
          padding: 0.05rem;
      }
      .search-btn {
        width: 0.26rem;
        height: 0.26rem;
        float: right;
        background: rgba(0, 0, 0, 0.5) url(../../assets/spot_search_btn.jpg);
        background-size: 100% 100%;
        cursor: pointer;
      }
      input::-webkit-input-placeholder {
        color: #ccc;
      }
    }
    .content {
      overflow: hidden;
      width: 100%;
      height: 92.5%;
      box-sizing: border-box;
      .topbar {
        width: 100%;
        height: 0.38rem;
        color: @light-blue;
        font-weight: bold;
        position: relative;
        background: url(../../assets/remenluxian/table_topbar_bg.png);
        background-size: 100% 100%;
        border: 1px solid #0f84b9;
        overflow: hidden;
        > div {
          float: left;
          height: 0.36rem;
          line-height: 0.36rem;
        }
        div:nth-child(1) {
          width: 60%;
        }
        div:nth-child(2) {
          width: 10%;
          border-right: 1px solid #0f84b9;
          border-left: 1px solid #0f84b9;
        }
        div:nth-child(3) {
          width: 10%;
          border-right: 1px solid #0f84b9;
          border-left: 1px solid #0f84b9;
         }
        div:nth-child(4) {
          width: 20%;
        }
      }
      .topbar::before {
        content: "";
        width: 0.02rem;
        height: 0.36rem;
        background: url(../../assets/remenluxian/table_topbar_line.png);
        background-size: 100% 100%;
        position: absolute;
        left: 0.04rem;
        top: 0;
      }
      .topbar::after {
        content: "";
        width: 0.02rem;
        height: 0.36rem;
        background: url(../../assets/remenluxian/table_topbar_line.png);
        background-size: 100% 100%;
        position: absolute;
        right: 0.04rem;
        top: 0;
      }
      .wrapper {
        overflow: hidden;
        width: 100%;
        height: calc(100% - 1.2rem);
      }
      .table {
        width: 100%;
        li {
          height: 0.36rem;
          line-height: 0.36rem;
          background: #07527c;
          border: 1px solid #0f84b9;
          border-bottom: none;
          font-size: 0.14rem;
          > div {
            height: 0.36rem;
            float: left;
          }
          div:nth-child(1) {
            width: 60%;
          }
          div:nth-child(2) {
            width: 10%;
            border-right: 1px solid #0f84b9;
            border-left: 1px solid #0f84b9;
          }
          div:nth-child(3) {
            width: 10%;
            border-right: 1px solid #0f84b9;
            border-left: 1px solid #0f84b9;
          }
          div:nth-child(4) {
            width: 20%;
          }
        }
        li:nth-child(1) {
          border-top: none;
        }
        li:nth-of-type(odd) {
          background: rgba(6, 51, 81, 0.84);
        }
        li:last-child {
          border-bottom: 1px solid #0f84b9;
        }
      }
      .page {
        width: 9rem;
        margin: 0 auto;
        background: #1b3e65;
      }
    }
  }
}
</style>
